export function calculateTip (total: number, tipPercentage: number): number {
    return total * (tipPercentage / 100)
}
